import LinkEmbedContainer from "./LinkEmbed";
export default LinkEmbedContainer;
export {useFetchLinkData} from "./hooks/useFetchLinkData";